export default function Forbidden() {
  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        textAlign: "center",
      }}
    >
      <h1 style={{ fontSize: "3rem", marginBottom: "10px" }}>403</h1>
      <h2 style={{ marginBottom: "10px" }}>Forbidden</h2>
      <p style={{ color: 'var(--natural-blue)' }}>
        You don’t have permission to view this page.
      </p>
    </div>
  );
}
